import * as types from "../actions/types";



const initialState = {

};


export default function parent_meetings(state = initialState, action) {
  switch (action.type) {
    case types.SET_PARENT_MEETINGS_LIST:
      return {
        ...state,
        parentMeetings: action.payload
      };
    case types.SET_PARENT_MEETINGS_FILES_LIST:
      return {
        ...state,
        parentMeetingsFiles: action.payload
      };
    case types.SET_PARENT_MEETINGS_ID:
      return {
        ...state,
        parentMeetingsId: action.payload
      };
    case types.SET_PARENT_MEETINGS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case types.SET_PARENT_MEETINGS_TEACHERS:
      return {
        ...state,
        parentMeetingsTeachers: action.payload
      };
    case types.SET_PARENT_MEETINGS_ROOMS:
      return {
        ...state,
        parentMeetingsRooms: action.payload
      };
    default:
      return state;
  }
}